export default "__VITE_ASSET__BWxmk1jh__"